import React, { useState } from "react"
import PropTypes from "prop-types"

import { connect } from "react-redux"

import { Link } from "react-router-dom"

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions"

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import EnvironmentBadge from "../Common/EnvironmentBadge"


import logoSm from "../../assets/images/amos-small.png";
import logoLightPng from "../../assets/images/amos-light.png";
import logoDark from "../../assets/images/amos-dark.png";



const Header = props => {
    const [menu, setMenu] = useState(false)
    const [isSearch, setSearch] = useState(false)
    const [socialDrp, setsocialDrp] = useState(false)
    const logoSubtitle = process.env.REACT_APP_APP_NAME || "CMS"

    function toggleFullscreen() {
        if (
            !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen()
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen()
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                )
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        }
    }
    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                        <div className="navbar-brand-box mt-3">
                            <Link to="/" className="logo logo-dark">
                                <span className="logo-sm text-center">
                                    <img src={logoSm} alt="" height="22" style={{ display: 'block' }} />
                                </span>
                                <span className="logo-lg text-center">
                                    <img src={logoDark} alt="" height="17" style={{ display: 'block' }} />
                                </span>
                            </Link>

                            <Link to="/" className="logo logo-light">
                                <span className="logo-sm text-center">
                                    <img src={logoSm} alt="" height="22" style={{ display: 'block' }} />
                                </span>
                                <span className="logo-lg text-center">
                                    <img src={logoLightPng} alt="" height="19" style={{ display: 'block' }} />
                                </span>
                            </Link>
                        </div>

                        <div className="text-body" style={{ display: 'flex', lineHeight: '1', margin: '0', marginTop: '22px' }}>{logoSubtitle}</div>

                        <button
                            type="button"
                            className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
                            data-toggle="collapse"
                            onClick={() => {
                                props.toggleLeftmenu(!props.leftMenu)
                            }}
                            data-target="#topnav-menu-content"
                        >
                            <i className="fa fa-fw fa-bars" />
                        </button>

                        <div className="position-relative fw-bold header-item d-flex align-items-center">
                        </div>

                    </div>

                    <div className="d-flex">
                        <EnvironmentBadge position="inline" className="ms-3 d-flex align-items-center" />
                        <div className="dropdown d-inline-block d-lg-none ms-2">
                            <button
                                type="button"
                                className="btn header-item noti-icon "
                                id="page-header-search-dropdown"
                                onClick={() => setSearch(!isSearch)}
                            >
                                <i className="mdi mdi-magnify" />
                            </button>
                            <div
                                className={
                                    isSearch
                                        ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                                        : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                }
                                aria-labelledby="page-header-search-dropdown"
                            >
                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={"Search" + "..."}
                                                aria-label="Recipient's username"
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" type="submit">
                                                    <i className="mdi mdi-magnify" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="dropdown d-none d-lg-inline-block ms-1">
                            <button
                                type="button"
                                className="btn header-item noti-icon "
                                onClick={() => {
                                    toggleFullscreen()
                                }}
                                data-toggle="fullscreen"
                            >
                                <i className="bx bx-fullscreen" />
                            </button>
                        </div>

                        <NotificationDropdown />

                        <ProfileMenu />

                        <div className="dropdown d-inline-block">
                            <button
                                onClick={() => {
                                    props.showRightSidebarAction(!props.showRightSidebar)
                                }}
                                type="button"
                                className="btn header-item noti-icon right-bar-toggle "
                            >
                                <i className="bx bx-cog bx-spin" />
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

Header.propTypes = {
    leftMenu: PropTypes.any,
    showRightSidebar: PropTypes.any,
    showRightSidebarAction: PropTypes.func,
    t: PropTypes.any,
    toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
    const { layoutType, showRightSidebar, leftMenu } = state.Layout
    return { layoutType, showRightSidebar, leftMenu }
}

export default connect(mapStatetoProps, {
    showRightSidebarAction,
    toggleLeftmenu,
})((Header))
